<template>
  <section
    id="liposuction"
  >
    <v-container mt-5>
      <v-layout>
        <v-flex>
          <h1>Liposuction</h1>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
  })
}
</script>
